import comp from "./QuestionBlanksTooltip";
export default comp;
